/*
 * Contenido propio por variante (flag settings.variant_overrides_enabled).
 * Al cambiar de variante pide la misma ficha con ?variant=ID y sustituye los bloques
 * marcados con data-vf (descripcion, faq, tech, short_description) y los metas del <head>.
 * El titulo lo sigue cambiando product.js (VariantCustomTitles).
 */
(() => {
  const cache = new Map();
  let lastRequest = 0;

  const metaSelectors = [
    ['meta[name="description"]', 'content'],
    ['meta[property="og:title"]', 'content'],
    ['meta[property="og:description"]', 'content']
  ];

  async function load(variantId) {
    if (!cache.has(variantId)) {
      const url = `${window.location.pathname}?variant=${variantId}`;
      cache.set(variantId, fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
        .then((text) => new DOMParser().parseFromString(text, 'text/html')));
    }
    return cache.get(variantId);
  }

  async function onVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    const request = ++lastRequest;
    let doc;
    try {
      doc = await load(variant.id);
    } catch (e) {
      cache.delete(variant.id);
      return;
    }
    // Si el usuario cambio de variante mientras llegaba la respuesta, esta ya no vale.
    if (request !== lastRequest) return;

    document.querySelectorAll('[data-vf]').forEach((target) => {
      const source = doc.querySelector(`[data-vf="${target.dataset.vf}"]`);
      if (source) target.innerHTML = source.innerHTML;
    });

    if (doc.title) document.title = doc.title;
    metaSelectors.forEach(([selector, attr]) => {
      const source = doc.querySelector(selector);
      const target = document.querySelector(selector);
      if (source && target) target.setAttribute(attr, source.getAttribute(attr));
    });
  }

  document.addEventListener('product:variant-change', onVariantChange);
})();
